// extracted by css-extract-rspack-plugin
export default {"pageHeading":"_b27a0267","pageTitle":"_e303ea2f"};